import { useState, useEffect, useContext } from "react";
import {
  Flex,
  Heading,
  Input,
  Button,
  InputGroup,
  Stack,
  InputLeftElement,
  chakra,
  Box,
  Image,
  FormControl,
  InputRightElement,
  FormErrorMessage,
  Text,
  useToast
} from "@chakra-ui/react";
import { FaUserAlt, FaLock } from "react-icons/fa";
import ralco_logo from './ralco_logo.png'
import axios from 'axios'
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

// login formik value
const loginValues = {
  email: '',
  password: '',
}

Yup.setLocale({
  string: {
    email: 'Invalid email format',
  },
});

// member Yup Validation schema
const loginSchema = Yup.object({
  email: Yup.string().email().required("Please enter your email"),
  password: Yup.string().min(6, 'Password must be at least 6 characters').required('Password is required'),
});

const CFaUserAlt = chakra(FaUserAlt);
const CFaLock = chakra(FaLock);

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [invalidError, setInvalidError] = useState(false)
  const navigate = useNavigate()
  const toast = useToast()
  const handleShowClick = () => setShowPassword(!showPassword);

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: loginValues,
      validationSchema: loginSchema,
      onSubmit: (values) => {
        let data = JSON.stringify({
          "email": values.email,
          "password": values.password
        });

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_RALCO_API_URL}/api/user-account/login`,
          headers: {
            'Content-Type': 'application/json'
          },
          data: data
        };

        axios.request(config)
          .then((response) => {
            setInvalidError(true)
            let data = response.data
            if (data.token) {
              localStorage.setItem("token", JSON.stringify(data.token))
              // localStorage.setItem("user", JSON.stringify({ email: data.userAccount.email, firstName: data.userAccount.firstName, lastName: data.userAccount.lastName, partyId: data.userAccount.partyId, userGroupMember: data.userAccount.UserGroupMember.map((x) => x.userGroupId), UserGroupPermission: data.userAccount.UserGroupPermission.map((z) => z.userPermissionId) }))
              //  add logic if data.userAccount.UserGroupPermission[0] === url
              
              if ((data.userAccount.UserGroupMember.map((x) => x.userGroupId)).includes('ADMIN')) {
                navigate('/orders/all')
                sessionStorage.setItem('myVar', 0)
              } else if ((data.userAccount.UserGroupMember.map((x) => x.userGroupId)).includes('MEMBER')) {
                  navigate('/order-delivery/all')
                // sessionStorage.setItem('myVar', 0)
              } else if ((data.userAccount.UserGroupMember.map((x) => x.userGroupId)).includes('DELEVERY_BOY')) {
                navigate('/order-delivery/all')
                sessionStorage.setItem('myVar', 0)
              }
              // window.location.reload()
              toast({
                title: `Welcome ${data.userAccount.firstName} ${data.userAccount.lastName}`,
                status: 'success',
                duration: 4000,
                position: 'top',
                isClosable: true,
              })
              
            } else {
              console.log('please enter correct details')
            }
          })
          .catch((error) => {
            if (error.response.data.message === "Invalid Email or Password") {
              setInvalidError(true)
            }
          });

      }
    })

  //if user sign in then send back to him home page if click or try to visit on sign up link or page
  useEffect(() => {
    const auth = localStorage.getItem("user");
    if (auth) {
      navigate("/");
    }
  }, [navigate]);


  return (
    <Flex
      width="100wh"
      height="100vh"
      backgroundColor="#f5f5f5"
      justifyContent="center"
      alignItems="center"
      flexDirection={'column'}
    >
      <Flex height={'6%'} justifyContent={'flex-start'} w={'100%'}>
        <Flex mt={4} alignItems={'center'}>
          <Image
            boxSize='33px'
            objectFit='fit'
            src={ralco_logo}
            alt='logo'
            mt={1}
            ml={4}
          />
          <Heading textAlign={"center"} color={'gray.700'} fontWeight={'bold'} fontSize={'26px'} letterSpacing={'1px'} ml={3}>EQUIPP</Heading>
        </Flex>
      </Flex>
      <Flex height={'94%'} >

        <Stack
          flexDirection="column"
          mb="2"
          justifyContent="center"
          alignItems="center"

        >
          <Flex w={'60%'} alignItems={'center'} flexDirection={'column'} ml={3}>

            <Heading textAlign={"center"} color={'teal.600'} fontWeight={'semibold'} fontSize={'38px'} letterSpacing={'1px'} ml={4}>Welcome</Heading>

          </Flex>

          <Box minW={{ base: "90%", md: "468px" }}>
            <form>
              <Stack
                spacing={4}
                p="1rem"
                backgroundColor="whiteAlpha.900"
                boxShadow="md"

              >
                {invalidError && <Text textAlign={'center'} color={'red.500'} fontWeight='semibold' fontSize={'14px'}>Invalid Email or Password</Text>}
                <FormControl isInvalid={errors.email && touched.email}>
                  <InputGroup>
                    <InputLeftElement
                      pointerEvents="none"
                      children={<CFaUserAlt color="gray.300" />}
                    />
                    <Input type="email" name="email" placeholder="email address" value={values.email} onChange={handleChange} onBlur={handleBlur} autoComplete='off' />
                  </InputGroup>
                  {errors.email && touched.email ? (
                    <FormErrorMessage>{errors.email}</FormErrorMessage>
                  ) : null}
                </FormControl>
                <FormControl isInvalid={errors.password && touched.password}>
                  <InputGroup>
                    <InputLeftElement
                      pointerEvents="none"
                      color="gray.300"
                      children={<CFaLock color="gray.300" />}
                    />
                    <Input
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      name={'password'}
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete='off'
                    />
                    <InputRightElement width="4.5rem">
                      <Button h="1.75rem" size="sm" onClick={handleShowClick}>
                        {showPassword ? "Hide" : "Show"}
                      </Button>
                    </InputRightElement>
                  </InputGroup>
                  {errors.password && touched.password ? (
                    <FormErrorMessage>{errors.password}</FormErrorMessage>
                  ) : null}
                </FormControl>
                <Button
                  borderRadius={0}
                  variant="solid"
                  colorScheme="blue"
                  width="full"
                  onClick={handleSubmit}
                  type={'submit'}
                >
                  Login
                </Button>
              </Stack>
            </form>
          </Box>
        </Stack>
        {/* <Box>
        New to us?{" "}
        <Link color="teal.500" href="#">
          Sign Up
        </Link>
      </Box> */}
      </Flex>
    </Flex>
  );
};

export default Login;
